import { render, staticRenderFns } from "./customerWxOrder.vue?vue&type=template&id=18d18e0a&scoped=true&"
import script from "./customerWxOrder.vue?vue&type=script&lang=js&"
export * from "./customerWxOrder.vue?vue&type=script&lang=js&"
import style0 from "./customerWxOrder.vue?vue&type=style&index=0&id=18d18e0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d18e0a",
  null
  
)

export default component.exports